var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhotoPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "r83ix1mlfa",
    width: "118.1%",
    height: "115.5%",
    x: "-9%",
    y: "-7.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199491914 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#r83ix1mlfa)",
    transform: "translate(-128 -3528) translate(102 3435)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.291 32.9c.938 0 1.644-.234 2.12-.703.474-.468.712-1.165.712-2.09v-9.336c0-.924-.238-1.62-.713-2.09-.475-.468-1.181-.702-2.119-.702h-1.807v-1.387c0-.925-.237-1.621-.713-2.09-.475-.469-1.181-.703-2.119-.703H13.186c-.944 0-1.652.233-2.124.698-.472.466-.708 1.164-.708 2.095v9.336c0 .924.236 1.62.708 2.09.472.468 1.18.703 2.124.703h1.806v1.386c0 .925.236 1.622.708 2.09.472.469 1.18.703 2.124.703h13.467zm-16.299-5.526l-1.787-.001c-.482 0-.851-.127-1.108-.38-.257-.255-.386-.632-.386-1.134v-9.19c0-.5.129-.88.386-1.137s.626-.386 1.108-.386h13.428c.475 0 .845.13 1.108.386.264.257.396.637.396 1.138l-.001 1.309H17.824c-.944 0-1.652.232-2.124.698-.472.465-.708 1.163-.708 2.094v6.603zm1.347 1.708V20.84c0-.501.13-.88.387-1.133.257-.254.63-.38 1.118-.38h13.418c.481 0 .853.126 1.113.38s.39.632.39 1.133v7.467l-3.437-3.229c-.195-.182-.412-.322-.65-.42-.237-.097-.48-.146-.727-.146-.254 0-.493.045-.718.136-.224.092-.444.232-.659.42l-4.072 3.594-1.611-1.455c-.196-.17-.396-.3-.601-.39-.205-.092-.415-.137-.63-.137-.208 0-.407.044-.596.132-.188.087-.377.216-.566.385l-2.159 1.885zm4.698-3.789c.39 0 .747-.096 1.07-.288.322-.192.579-.451.77-.776.193-.326.289-.687.289-1.084 0-.385-.096-.74-.288-1.065-.192-.325-.45-.586-.772-.781-.322-.195-.678-.293-1.069-.293-.397 0-.757.098-1.079.293-.322.195-.58.456-.771.781-.193.326-.289.68-.289 1.065 0 .397.096.758.289 1.084.192.325.449.584.771.776.322.192.682.288 1.08.288z",
    transform: "translate(32 95) translate(.011)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoPurple);
export default __webpack_public_path__ + "static/media/ic_photo_purple.c61bdcff26ffedc258540eee6f532db4.svg";
export { ForwardRef as ReactComponent };